<script setup lang="ts">
import { isEmpty } from 'es-toolkit/compat'

interface UserLoggedOutMessage {
    title: string
    description: string
}

const userLoggedOutMessage = ref<UserLoggedOutMessage | null>(null)

const checkLoggedOutByReason = () => {
    const userForcedLoggedOut = useCookie<string | null>('userForcedLoggedOut')

    if (userForcedLoggedOut.value === 'single_session_rule') {
        userLoggedOutMessage.value = {
            title: 'Du er blevet logget ud',
            description: 'Vi har registreret et login fra en anden enhed og du er derfor blevet logget ud her.'
        }
    }
}

const clearCookie = () => {
    const userForcedLoggedOut = useCookie<string | null>('userForcedLoggedOut')
    userForcedLoggedOut.value = null
}

const clearMessageAndCookie = () => {
    clearCookie()

    userLoggedOutMessage.value = null
}

onMounted(() => {
    checkLoggedOutByReason()
    clearCookie()
})

onBeforeUnmount(() => {
    clearMessageAndCookie()
})
</script>

<template>
    <LazyUIDialog
        v-if="!isEmpty(userLoggedOutMessage)"
        :model-value="true"
        class="user-logged-out-message"
        data-test="user-logged-out-message"
        :show-header="false"
        :show-footer="false"
        transition-name="bounce-down"
        variant="promotion"
        @close="clearMessageAndCookie"
    >
        <div class="user-logged-out-message__content">
            <NuxtImg
                class="user-logged-out-message__image"
                src="/media/game/inspector-loop.png"
                loading="lazy"
                decoding="async"
                preset="local"
                provider="cloudflare"
            />

            <h2 class="user-logged-out-message__title">
                {{ userLoggedOutMessage?.title }}
            </h2>
            <p class="user-logged-out-message__description">
                {{ userLoggedOutMessage?.description }}
            </p>
            <UIButton
                size="xl"
                class="user-logged-out-message__button"
                as="cta"
                elevated
                @click="clearMessageAndCookie()"
            >
                OK
            </UIButton>
        </div>
    </LazyUIDialog>
</template>

<style lang="scss" scoped>
.user-logged-out-message {
    &__content {
        margin: 20px 0;
        text-align: center;
        display: flex;
        flex-direction: column;
        gap: 15px;
    }

    &__image {
        height: 74px;
        object-fit: contain;
    }

    &__title {
        font-weight: $text-extra-bold;
        font-size: $font-size-base;
    }

    &__description {
        font-size: $font-size-base;
    }
}
</style>
